// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { DocumentRecipient } from './document-recipient';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class DocumentRecipientAction extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  documentActionId!: number;
  actionTime!: Date;
  actionTypeLookupId!: number;
  actionUser?: string;
  documentRecipientId!: number;
  documentRecipient!: DocumentRecipient;
}

